import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Card from "../Card";
import Select from "react-select";
import {
  addVehicle,
  getVehicle,
  updateVehicle,
} from "../../services/OrganisationServices/transportManagemetService";
import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import { useGlobalState } from "../../services/hostelConst";
import { selectStyle } from "../../services/constant";

const AddVehicleForm = ({ refresh, navigate }) => {
  const { closeModal, masterTableState, updateMasterTable, modalState } =
    useGlobalState();
  const id = modalState.id;

  const [loadingData, setLoadingData] = useState(modalState.isEditing);

  const prepareFormData = (data = null) => {
    return {
      vehicleNumber: data == null ? "" : data.VEHICLE_NUMBER,
      vehicleType: data == null ? "" : data.VEHICLE_TYPE,
      capacity: data == null ? "" : data.CAPACITY,
      model: data == null ? "" : data.MODEL,
      make: data == null ? "" : data.MAKE,
      year: data == null ? "" : data.YEAR,
      registrationNumber: data == null ? "" : data.REGISTRATION_NUMBER,
      fuelType: data == null ? "" : data.FUEL_TYPE,
      description: data == null ? "" : data.DESCRIPTION,
    };
  };

  const [formData, setFormData] = useState(prepareFormData());
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const getVehicleDetailsData = async (id) => {
    setLoadingData(true);
    var res = await getVehicle(id);
    if (res.status == "success") {
      setFormData(prepareFormData(res.data));
    } else {
      showErrorMessages({ data: res, navigate });
      closeModal();
    }
    setLoadingData(false);
  };

  useEffect(() => {
    if (modalState.isEditing && id) {
      getVehicleDetailsData(id);
    }
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.vehicleNumber.trim()) {
      newErrors.vehicleNumber = "Vehicle number is required";
    }
    if (!formData.vehicleType.trim()) {
      newErrors.vehicleType = "Vehicle type is required";
    }
    if (!formData.capacity.trim()) {
      newErrors.capacity = "Capacity is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const submitData = {
        vehicleNumber: formData.vehicleNumber,
        vehicleType: formData.vehicleType,
        capacity: parseInt(formData.capacity),
        model: formData.model,
        make: formData.make,
        year: formData.year,
        registrationNumber: formData.registrationNumber,
        fuelType: formData.fuelType,
        description: formData.description,
      };

      let res;
      if (modalState.isEditing) {
        submitData.entityId = id;
        res = await updateVehicle(submitData);
      } else {
        res = await addVehicle(submitData);
      }

      if (res.status === "success") {
        callToast(
          "success",
          "Success",
          `Vehicle ${modalState.isEditing ? "updated" : "added"} successfully`
        );
        updateMasterTable(true);
        closeModal();
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error submitting vehicle:", error);
    }
    setLoading(false);
  };

  if (loadingData) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Card className="shadow-sm">
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Vehicle Number *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.vehicleNumber}
                  onChange={(e) =>
                    handleChange("vehicleNumber", e.target.value)
                  }
                  isInvalid={!!errors.vehicleNumber}
                  placeholder="Enter vehicle number"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.vehicleNumber}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Vehicle Type *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.vehicleType}
                  onChange={(e) => handleChange("vehicleType", e.target.value)}
                  isInvalid={!!errors.vehicleType}
                  placeholder="Enter vehicle type"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.vehicleType}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Capacity *</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.capacity}
                  onChange={(e) => handleChange("capacity", e.target.value)}
                  isInvalid={!!errors.capacity}
                  placeholder="Enter capacity"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.capacity}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Model</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.model}
                  onChange={(e) => handleChange("model", e.target.value)}
                  placeholder="Enter model"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Make</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.make}
                  onChange={(e) => handleChange("make", e.target.value)}
                  placeholder="Enter make"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Year</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.year}
                  onChange={(e) => handleChange("year", e.target.value)}
                  placeholder="Enter year"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Registration Number</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.registrationNumber}
                  onChange={(e) =>
                    handleChange("registrationNumber", e.target.value)
                  }
                  placeholder="Enter registration number"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fuel Type</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.fuelType}
                  onChange={(e) => handleChange("fuelType", e.target.value)}
                  placeholder="Enter fuel type"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={formData.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Enter description"
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  {modalState.isEditing ? "Updating..." : "Adding..."}
                </>
              ) : modalState.isEditing ? (
                "Update Vehicle"
              ) : (
                "Add Vehicle"
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default AddVehicleForm;
